export const baseColour = "#a93c40"
export const secondaryColour = '#a93c40'
export const baseURL = 'https://api.mplan.ashesi.edu.gh/api'
// 'linear-gradient(90deg, rgba(6,149,217,1) 35%, rgba(79,198,255,1) 100%);' 
// https://whale-app-dqf3t.ondigitalocean.app/api
// live: https://sea-turtle-app-4h79f.ondigitalocean.app/api/
// https://api.mplan.ashesi.edu.gh/api/